import React, { useState, useRef } from "react";
import { Button, Modal, Popconfirm, Image } from "antd";
import { ASSET_API_AUTO_BANNER } from "../../../../config";
import {
  BsFillClockFill,
  BsFillCaretUpFill,
  BsFillCaretDownFill,
  BsFillTrashFill,
} from "react-icons/bs";

const HistoryDesign = ({
  historyData,
  indexActive,
  onSelect,
  onDeleteAll,
  onDeleteItem,
}) => {
  const [open, setOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(historyData.length - 1);
  const slider = useRef();

  const handleOk = () => {
    setOpen(false);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const updateSlider = (v) => {
    const offset = -v * 300; // 300 is the height of each slide
    slider.current.style.transform = `translateY(${offset}px)`;
  };

  const showModal = () => {
    setOpen(true);
    setCurrentIndex(historyData.length - 1);
    setTimeout(() => {
      updateSlider(indexActive);
    }, 1000);
  };

  const handleDeleteAll = () => {
    setOpen(false);
    onDeleteAll(true);
  };

  const handleNext = () => {
    if (currentIndex < historyData.length - 1) {
      const newValue = currentIndex + 1;
      setCurrentIndex(newValue);
      updateSlider(newValue);
    }
  };

  const handlePrev = () => {
    if (currentIndex > 0) {
      const newValue = currentIndex - 1;
      setCurrentIndex(newValue);
      updateSlider(newValue);
    }
  };

  const onChooseHistory = () => {
    onSelect(currentIndex);
    setOpen(false);
  };
  const handleDeleteItem = () => {
    onDeleteItem(currentIndex);
    if (currentIndex == 0 && historyData.length >= 1) {
      setCurrentIndex(0);
      updateSlider(0);
    }
    if (historyData.length > 1 && currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
      updateSlider(currentIndex - 1);
    }
  };
  return (
    <>
      {historyData.length > 0 && (
        <>
          <Button
            onClick={showModal}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: 5,
              height: 35,
              width: "30%",
              marginRight: 5,
            }}
          >
            <BsFillClockFill /> <span style={{ marginLeft: 5 }}>History</span>
          </Button>
          <Modal
            title={
              <div className="model-history-autobanner-header">
                <div className="model-history-autobanner-header__left">
                  History:{" "}
                </div>
                <div className="model-history-autobanner-header__right">
                  <Popconfirm
                    placement="bottomLeft"
                    title={"Are you sure you want to delete all history?"}
                    onConfirm={handleDeleteAll}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button
                      className="btn-trash-all-history-autobanner"
                      type="dashed"
                      title="Delete all history"
                    >
                      <BsFillTrashFill
                        style={{
                          marginRight: "5px",
                        }}
                      />{" "}
                      Delete all
                    </Button>
                  </Popconfirm>
                </div>
              </div>
            }
            visible={open}
            onOk={handleOk}
            onCancel={handleCancel}
            className="model-history-autobanner"
            closable={true}
            width={500}
            footer={
              <>
                <div className="model-history-autobanner-footer">
                  <div className="model-history-autobanner-footer__left">
                    <Button
                      disabled={!(currentIndex > 0)}
                      onClick={handlePrev}
                      className="model-history-autobanner-footer__arrow-btn"
                      id="prev"
                    >
                      <BsFillCaretUpFill />
                    </Button>
                    <Button
                      disabled={!(currentIndex < historyData.length - 1)}
                      onClick={handleNext}
                      className="model-history-autobanner-footer__arrow-btn"
                      id="next"
                    >
                      <BsFillCaretDownFill />
                    </Button>
                  </div>
                  <div className="model-history-autobanner-footer__right">
                    <Popconfirm
                      placement="topRight"
                      title="Are you sure to delete this?"
                      onConfirm={handleDeleteItem}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Button
                        style={{
                          borderColor: "red",
                          color: "red",
                        }}
                        type="dashed"
                      >
                        Delete
                      </Button>
                    </Popconfirm>

                    <Button type="primary" onClick={onChooseHistory}>
                      Choose
                    </Button>
                  </div>
                </div>
              </>
            }
          >
            <div className="slider-container-history-autobanner">
              <div ref={slider} className="slider-history autobanner">
                {historyData.map((item, index) => (
                  <div key={index} className="slide-history-autobanner">
                    <div className="slide-history-item">
                      <Image.PreviewGroup>
                        <ul className="slide-history-list-autobanner">
                          {item?.keys.map((e, inx) => (
                            <li
                              key={inx}
                              className="li-select-background-autobanner"
                            >
                              <div
                                style={{
                                  width: "100%",
                                  aspectRatio: "1/1",
                                }}
                              >
                                <Image
                                  style={{
                                    height: "100%",
                                    borderRadius: 5,
                                  }}
                                  src={ASSET_API_AUTO_BANNER + e}
                                />
                              </div>
                            </li>
                          ))}
                        </ul>
                      </Image.PreviewGroup>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </Modal>
        </>
      )}
    </>
  );
};

export default HistoryDesign;
